/**
 * @freesewing/plugin-i18n | v2.16.2
 * A FreeSewing plugin for pattern translation
 * (c) 2021 Joost De Cock <joost@joost.at> (https://github.com/joostdecock)
 * @license MIT
 */
var e={name:"@freesewing/plugin-i18n",version:"2.16.2",hooks:{preRender:function(e){!1===e.attributes.get("freesewing:plugin-i18n")&&e.attributes.set("freesewing:plugin-i18n","2.16.2")},insertText:function(e,i,n){if(!1===n)return console.log("No data was passed to the i18n plugin. This plugin won't do much without injecting data into it"),i;let t=n.prefix||"";return void 0===n.strings[e][t+i]?i:n.strings[e][t+i]}}};export default e;
//# sourceMappingURL=index.mjs.map
